(() => {
  const normalizePhone = (dialCode, rawNumber) => {
    const value = rawNumber.trim();
    if (!value) return '';
    if (value.startsWith('+')) return `+${value.slice(1).replace(/\D/g, '')}`;
    if (value.startsWith('00')) return `+${value.slice(2).replace(/\D/g, '')}`;
    const digits = value.replace(/\D/g, '').replace(/^0+/, '');
    const dialDigits = dialCode.replace(/\D/g, '');
    if (!digits) return '';
    if (dialDigits.startsWith('1') && dialDigits.length > 1) return `+1${digits}`;
    if (digits.startsWith(dialDigits)) return `+${digits}`;
    return `+${dialDigits}${digits}`;
  };

  const setupCountryTypeahead = (select) => {
    let query = '';
    let resetTimer = null;

    select.addEventListener('keydown', (e) => {
      if (e.key.length !== 1 || e.ctrlKey || e.metaKey || e.altKey) return;

      clearTimeout(resetTimer);
      resetTimer = setTimeout(() => {
        query = '';
      }, 1000);

      query += e.key.toLowerCase();

      const options = Array.from(select.options);
      const getCountryName = (opt) => opt.text.toLowerCase();

      let targetIndex = -1;

      const isRepeatedChar = query.length > 1 && query.split('').every((c) => c === query[0]);
      const searchChar = query[0];

      if (query.length === 1 || isRepeatedChar) {
        const matches = [];
        options.forEach((opt, idx) => {
          if (getCountryName(opt).startsWith(searchChar)) {
            matches.push(idx);
          }
        });

        if (matches.length > 0) {
          const currentPos = matches.indexOf(select.selectedIndex);
          if (currentPos !== -1 && currentPos < matches.length - 1) {
            targetIndex = matches[currentPos + 1];
          } else {
            targetIndex = matches[0];
          }
        }
      } else {
        targetIndex = options.findIndex((opt) => getCountryName(opt).startsWith(query));
      }

      if (targetIndex !== -1) {
        e.preventDefault();
        select.selectedIndex = targetIndex;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-contact-phone]').forEach((field) => {
      const form = field.closest('form');
      const country = field.querySelector('[data-country-code]');
      const phone = field.querySelector('[data-phone-number]');
      const firstName = form?.querySelector('[name="contact[First name]"]');
      const lastName = form?.querySelector('[name="contact[Last name]"]');
      const fullName = form?.querySelector('[data-contact-full-name]');

      if (!form || !country || !phone) return;

      setupCountryTypeahead(country);

      form.addEventListener('submit', () => {
        if (fullName && firstName && lastName) {
          fullName.value = `${firstName.value.trim()} ${lastName.value.trim()}`.trim();
        }
        phone.value = normalizePhone(country.value, phone.value);
        phone.setAttribute('autocomplete', 'tel');
      });
    });
  });
})();
